import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { Dependency } from '../../models/stack9/Dependency';
import { DependencyForm } from './DependencyForm';

const { ScreenProvider, useScreenQuery } = ui;
const S9Drawer = ui.S9Drawer.default;

type DependencyDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<Dependency>;
};

export const DependencyDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: DependencyDrawerProps) => {
  const { data } = useScreenQuery<any>('getRequirementDetails', {
    vars: {
      id: initialValues?.requirement_id,
    },
  });
  const requirement = data[0];
  return (
    <ScreenProvider relativePath={AppRoutes.RequirementDetail}>
      <S9Drawer open={open} width={650} onClose={onClose} closable>
        {requirement && (
          <DependencyForm
            onClose={onClose}
            countryTemplateId={requirement.country_template_id}
            id={id}
            initialValues={initialValues}
          />
        )}
      </S9Drawer>
    </ScreenProvider>
  );
};
